var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fb-icon--brown.fbda7af8775c2a3196af2caac36e1d4d copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy",
    transform: "translate(-1141, -80)",
    fill: "#00467D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb-icon--red",
    transform: "translate(768, 80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fb-icon--brown.fbda7af8775c2a3196af2caac36e1d4d-copy",
    transform: "translate(373, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.52425265,18 L5.52425265,8.99894615 L7.98198915,8.99894615 L8.30769231,5.89713314 L5.52425265,5.89713314 L5.52842829,4.34464587 C5.52842829,3.53564531 5.60446053,3.10216429 6.75381681,3.10216429 L8.29029363,3.10216429 L8.29029363,0 L5.83220916,0 C2.87965438,0 1.84043163,1.50471302 1.84043163,4.03516716 L1.84043163,5.89748444 L0,5.89748444 L0,8.99929743 L1.84043163,8.99929743 L1.84043163,18 L5.52425265,18 Z",
    id: "Shape-Copy-15"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIconBlue);
export default __webpack_public_path__ + "static/media/fb-icon--blue.5ca0464efc9e6b0145b771998829e50d.svg";
export { ForwardRef as ReactComponent };